/**
 * Justification reason keys for sensitivity label downgrade
 */ export var JustificationReasonKeys = /*#__PURE__*/ function(JustificationReasonKeys) {
    JustificationReasonKeys["NotApplicable"] = "NotApplicable";
    JustificationReasonKeys["Incorrect"] = "Incorrect";
    JustificationReasonKeys["Other"] = "Other";
    return JustificationReasonKeys;
}({});
